// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__AxkJb","primary":"Badge_primary__SHKod","secondary":"Badge_secondary__SDZpB"};